import { render } from "./MessengerBox.vue?vue&type=template&id=4ca7ee50&scoped=true"
import script from "./MessengerBox.vue?vue&type=script&lang=js"
export * from "./MessengerBox.vue?vue&type=script&lang=js"

import "./MessengerBox.vue?vue&type=style&index=0&id=4ca7ee50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca7ee50"]])

export default __exports__